export const GraphQLAPI = function (apiConfig, http, helpers) {
  let self = this;
  let apiPath = `${process.env.BASENAME}/app/api/web/graphql`;
  self.get = (query) => {
    return http.get(apiPath, {
      query
    })
  };

  self.getPersistedPath = (vanityUrl, hash, options) => {
    return http.get(`${apiPath}/page/${encodeURIComponent(vanityUrl)}/${encodeURIComponent(hash)}`,options);
  }

  self.getPersistedQuery = (vanityUrl, hash) => {
    let query = {
      vanityUrl: vanityUrl,
      hash: encodeURIComponent(hash)
    }
    return http.get(apiPath, {
      params: query
    });
  }

}
